'use client';

import React, { useEffect, useState } from 'react';

import IosPwaGuideModal from '@/widgets/IosPwaGuideModal';

import { isAppPwaHost, isIosDevice, isPwaStandalone } from '@/utilities/pwa';

const IOS_PWA_GUIDE_SESSION_KEY = 'ios-pwa-guide-seen';

const IosPwaInstallPrompt = () => {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (!isAppPwaHost() || !isIosDevice() || isPwaStandalone()) {
            return;
        }

        if (sessionStorage.getItem(IOS_PWA_GUIDE_SESSION_KEY)) {
            return;
        }

        setOpen(true);
    }, []);

    const handleClose = () => {
        sessionStorage.setItem(IOS_PWA_GUIDE_SESSION_KEY, '1');
        setOpen(false);
    };

    return <IosPwaGuideModal open={open} onClose={handleClose} />;
};

export default IosPwaInstallPrompt;
